const RAZORPAY_CHECKOUT_SCRIPT =
  "https://checkout.razorpay.com/v1/checkout.js"

let checkoutScriptPromise

export const loadRazorpayCheckout = () => {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return Promise.reject(new Error("Razorpay Checkout requires a browser"))
  }

  if (window.Razorpay) return Promise.resolve(window.Razorpay)
  if (checkoutScriptPromise) return checkoutScriptPromise

  checkoutScriptPromise = new Promise((resolve, reject) => {
    const existingScript = document.querySelector(
      `script[src="${RAZORPAY_CHECKOUT_SCRIPT}"]`
    )
    const script = existingScript || document.createElement("script")

    const handleLoad = () => {
      if (window.Razorpay) resolve(window.Razorpay)
      else {
        script.remove()
        checkoutScriptPromise = undefined
        reject(new Error("Razorpay Checkout did not initialize"))
      }
    }
    const handleError = () => {
      script.remove()
      checkoutScriptPromise = undefined
      reject(new Error("Unable to load Razorpay Checkout"))
    }

    script.addEventListener("load", handleLoad, { once: true })
    script.addEventListener("error", handleError, { once: true })

    if (!existingScript) {
      script.src = RAZORPAY_CHECKOUT_SCRIPT
      script.async = true
      document.body.appendChild(script)
    }
  })

  return checkoutScriptPromise
}
